import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface FirmasState {
  uploadType: 'PDF' | 'EXCEL' | 'FOLDER' | null
  selectedSignerIds: string[]
  excelName: string | null
  pdfName: string | null
  selectedTemplateId: string | null
  certificateTitle: string | null // <-- NUEVO: Para el título dinámico
}

const initialState: FirmasState = {
  uploadType: null,
  selectedSignerIds: [],
  excelName: null,
  pdfName: null,
  selectedTemplateId: null,
  certificateTitle: null, // <-- NUEVO
}

export const tempFiles = {
  excel: null as File | null,
  pdf: null as File | null
}

export const firmasSlice = createSlice({
  name: 'firmas',
  initialState,
  reducers: {
    setExcelFile: (state, action: PayloadAction<File>) => {
      state.excelName = action.payload.name
      tempFiles.excel = action.payload
    },
    setPdfFile: (state, action: PayloadAction<File>) => {
      state.pdfName = action.payload.name
      tempFiles.pdf = action.payload
    },
    setSelectedTemplateId: (state, action: PayloadAction<string | null>) => {
      state.selectedTemplateId = action.payload
    },
    setCertificateTitle: (state, action: PayloadAction<string | null>) => { // <-- NUEVO
      state.certificateTitle = action.payload
    },
    clearFiles: (state, action: PayloadAction<'excel' | 'pdf'>) => {
      if (action.payload === 'excel') {
        state.excelName = null
        tempFiles.excel = null
      } else {
        state.pdfName = null
        tempFiles.pdf = null
        state.selectedTemplateId = null
      }
    },
    // 👇 AÑADE ESTO 👇
    clearSigners: (state) => {
      state.selectedSignerIds = []; // Esto vacía el arreglo
    },
    toggleSigner: (state, action: PayloadAction<string>) => {
      const id = action.payload
      state.selectedSignerIds = state.selectedSignerIds.includes(id)
        ? state.selectedSignerIds.filter(sId => sId !== id)
        : [...state.selectedSignerIds, id]
    },
    resetSolicitud: (state) => {
      Object.assign(state, initialState)
      tempFiles.excel = null
      tempFiles.pdf = null
    },
    setUploadType: (state, action: PayloadAction<'PDF' | 'EXCEL' | 'FOLDER' | null>) => {
      state.uploadType = action.payload
    }  
  },
})

export const { 
  setExcelFile, 
  setPdfFile, 
  setSelectedTemplateId, 
  setCertificateTitle,
  clearFiles, 
  toggleSigner, 
  resetSolicitud, 
  setUploadType,
  clearSigners
} = firmasSlice.actions

export default firmasSlice.reducer